import {useContext, useEffect} from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Routes as Switch, 
  Link, createBrowserRouter,createRoutesFromElements, RouterProvider, BrowserRouter} from 'react-router-dom';// desde la 6 es routes no switch
import { UserModel } from './interfaces/UserModel';
import Layout from './componentes/Layout/Layout'
import Ayuda from './componentes/Ayuda';
import Home from './componentes/Home';
import NotFound from './componentes/NotFound';
import { Proyecto } from './componentes/Proyectos/Proyecto';
import { ProyectosAprob } from './componentes/ProyectosAprob';
import { BusquedaProyectos } from './componentes/BuquedaProyectos';
import PortalInvestigacionLayout from './componentes/Layout/PortalInvestigacionLayout';
import { CasUserContext, CasUserContextProvider, useCasUserContext } from './services/casUserContext';
import useCas from './Hooks/useCas';
import FormularioProducto from './componentes/Productos/FormularioProducto';
import { Productos } from './componentes/Productos/Productos';
import Portal from './componentes/PortalInvestigacion';
import SolicitarFirmaDecano from './componentes/Certificados/SolicitarFirmaDecano';
import React from "react";
import MisCertificados from './componentes/Certificados/MisCertificados';
import { BusquedaScopus } from './componentes/Scopus/BusquedaScopus';
import { AppRouter } from './Router';
import BusquedaCertificado from './componentes/Certificados/BusquedaCertificado';
interface GestionProyectos{
  currentUser: UserModel,
  token: string,
}

//Algo viejo pero otra forma de rotues pero para mantenerlo dentro de app
const router = createBrowserRouter(
  createRoutesFromElements(
    <React.Fragment>
      <Route path='/' element={<Layout isSecure={false}/>} errorElement={<NotFound />}>          
        <Route index element={<Home />} />
        <Route path='ayuda' element={<Ayuda />}/>
        <Route path='proyectosAprobados/:id' element={<ProyectosAprob />}/>
        <Route path='busquedaProyectos' element={<BusquedaProyectos />}/>
        <Route path='busquedaScopus' element={<BusquedaScopus />}/>
        <Route path='proyecto/:idInv/:idPro' element={<Proyecto />}/>
        <Route path='MisProductos' element={<Productos />}/>
        <Route path='producto/:idProducto' element={<FormularioProducto />}/>
        <Route path='SolicitarFirmaDec' element={<SolicitarFirmaDecano />}/>
        <Route path='MisCertificados' element={<MisCertificados/>} />
      </Route>

      <Route path='/inicio' element={<PortalInvestigacionLayout />} errorElement={<NotFound />}  >
          <Route path='portalinvestigacion' element={<Portal />}/>
          <Route  path="BusquedaCertificado" element={<BusquedaCertificado/>} />
      </Route>
    </React.Fragment>
      
  )
)

export function App() {

  return (
    // <RouterProvider router={router} />
    <BrowserRouter>
    <AppRouter />
    </BrowserRouter>
  );
}

